import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import moment from 'moment';
moment.locale('id')

import { library } from '@fortawesome/fontawesome-svg-core';
import {faExternalLinkAlt, faTimes, faFileDownload, faUserCheck, faInfoCircle, faPaperPlane, faRedo} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import './assets/styles/app.scss'

library.add(faExternalLinkAlt, faTimes, faFileDownload, faUserCheck, faInfoCircle, faPaperPlane, faRedo);

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(VueMoment, { moment });

Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
